import React from 'react';
import { createPortal } from 'react-dom';
import { Modal } from '../../ui/Modal';
import { RuleEditor } from './RuleEditor';
import type { FormField, FormPage, FieldRule, ScoreVariable } from '../../../types/forms';

interface RuleEditorModalProps {
  isOpen: boolean;
  onClose: () => void;
  field: FormField;
  allFields: FormField[];
  scoringVariables: ScoreVariable[];
  onUpdateRules: (fieldId: string, rules: FieldRule[]) => void;
  pages?: FormPage[];
}

export function RuleEditorModal({
  isOpen,
  onClose,
  field,
  allFields,
  scoringVariables,
  onUpdateRules,
  pages,
}: RuleEditorModalProps) {
  if (!isOpen) return null;

  const rulesCount = field.rules?.length || 0;

  return createPortal(
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Regras — ${field.label}${rulesCount > 0 ? ` (${rulesCount})` : ''}`}
      size="lg"
    >
      <RuleEditor
        field={field}
        allFields={allFields}
        scoringVariables={scoringVariables}
        onUpdateRules={onUpdateRules}
        pages={pages}
      />
    </Modal>,
    document.body
  );
}
